import React from 'react';
import Navigation from '@/components/Navigation';
import ContactHero from '@/components/contact/ContactHero';
import ContactForm from '@/components/contact/ContactForm';
import FAQSection from '@/components/contact/FAQSection';
import NewsletterCTA from '@/components/contact/NewsletterCTA';
import Footer from '@/components/Footer';

const Contact = () => {
  return (
    <div className="min-h-screen bg-cloud-white">
      <Navigation />
      <ContactHero />
      <div className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <ContactForm />
          </div>
        </div>
      </div>
      <FAQSection />
      <NewsletterCTA />
      <Footer />
    </div>
  );
};

export default Contact;
